import * as Yup from 'yup';
import { VALIDATION_ERROR } from 'utils/enums';
import { phoneValidationSchema } from './phone.schema';

export const addressVlidationSchema = Yup.object().shape({
	address: Yup.string().required("Адреса обов'язкове поле"),
	flat: Yup.string().required("№ квартири обов'язкове поле"),
});

export const passwordValidationSchema = Yup.string().min(6, 'Пароль має містити 6 цифр');

export const loginValidationSchema = Yup.object().shape({
	phone: phoneValidationSchema,
	password: passwordValidationSchema,
});

export const resetRadabankPasswordSecretValidationSchema = Yup.object().shape({
	secret: Yup.string().required(VALIDATION_ERROR.REQUIRED).min(3, 'Кодове слово має бути не менше 3 символів'),
});

export const resetRadabankPasswordDocumentValidationSchema = Yup.object().shape({
	docnumber: Yup.string()
		.required(VALIDATION_ERROR.REQUIRED)
		.min(6, 'Номер паспорту має бути не менше 6 символів')
		.matches(/^\d+$/, 'Номер паспорту має містити лише цифри'),
});

export const resetRadabankPasswordBirthdyValidationSchema = Yup.object().shape({
	birthday: Yup.string().required(VALIDATION_ERROR.REQUIRED),
});
